import styled from '@emotion/styled'

export const DateInputWrapper = styled.div`
  position: relative;
`
